type Props = {
  width?: string;
  height?: string;
  viewBox?: string;
  strokeColor?: string;
};

/**
 * Stroked globe (circle + meridians) used by the translation controls —
 * the language-chip trigger and the empty-state Translate button share
 * this glyph so the control keeps the same visual anchor before and
 * after a translation exists. Distinct from `EarthIcon` (filled glyph).
 */
const GlobeIcon = (props: Props) => {
  const {
    width = '18',
    height = '18',
    viewBox = '0 0 24 24',
    strokeColor = 'currentColor',
  } = props;
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none">
      <circle cx="12" cy="12" r="9" stroke={strokeColor} strokeWidth="2" />
      <path
        d="M3 12h18M12 3c2.5 3 2.5 15 0 18M12 3c-2.5 3-2.5 15 0 18"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default GlobeIcon;
